import { Outlet, Link, useNavigate, useLocation } from 'react-router-dom';
import { useState } from 'react';
import { ShoppingBag, ShoppingCart, User, Heart, ClipboardList, Menu, X, LogOut, LogIn } from 'lucide-react';
import { useAuthStore, useCartStore } from '../../store';
import toast from 'react-hot-toast';
import { authApi } from '../../api/services';
import './CustomerLayout.css';

export default function CustomerLayout() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const { isAuthenticated, user, logout } = useAuthStore();
  const { getItemCount } = useCartStore();
  const navigate = useNavigate();
  const location = useLocation();

  const foodCount = getItemCount('food');
  const marketCount = getItemCount('market');
  const totalCount = foodCount + marketCount;

  const handleLogout = async () => {
    try {
      const accessToken = localStorage.getItem('access_token') || '';
      const refreshToken = localStorage.getItem('refresh_token') || '';
      await authApi.logout({ accessToken, refreshToken });
    } catch {/* ignore */}
    logout();
    toast.success('Çıkış yapıldı');
    navigate('/');
  };

  return (
    <div className="customer-layout">
      {/* ─── Navbar ─── */}
      <nav className="navbar">
        <div className="container navbar-inner">
          <Link to="/" className="navbar-brand">
            <img src="/logo-transparent.png" alt="Zavadak" className="navbar-logo" />
          </Link>

          <div className="navbar-links">
            <Link to="/food" className={`nav-link ${location.pathname.startsWith('/food') ? 'active' : ''}`}>
              <ShoppingBag size={16} /> Yemek
            </Link>
            <Link to="/market" className={`nav-link ${location.pathname.startsWith('/market') ? 'active' : ''}`}>
              🛒 Market
            </Link>
          </div>

          <div className="navbar-actions">
            <Link to="/cart" className="nav-cart-btn">
              <ShoppingCart size={20} />
              {totalCount > 0 && <span className="cart-badge">{totalCount}</span>}
            </Link>

            {isAuthenticated ? (
              <div className="nav-user-menu" onMouseLeave={() => setUserMenuOpen(false)}>
                <button
                  className="nav-user-btn"
                  onClick={() => setUserMenuOpen(!userMenuOpen)}
                >
                  <User size={16} />
                  <span>{user?.role === 'Customer' ? 'Hesabım' : user?.role}</span>
                </button>
                <div className={`user-dropdown ${userMenuOpen ? 'is-open' : ''}`}>
                  {user?.role === 'Customer' && (
                    <>
                      <Link to="/orders" onClick={() => setUserMenuOpen(false)} className="dropdown-item">
                        <ClipboardList size={14} /> Siparişlerim
                      </Link>
                      <Link to="/favorites" onClick={() => setUserMenuOpen(false)} className="dropdown-item">
                        <Heart size={14} /> Favorilerim
                      </Link>
                      <Link to="/profile" onClick={() => setUserMenuOpen(false)} className="dropdown-item">
                        <User size={14} /> Profilim
                      </Link>
                    </>
                  )}
                  {(user?.role === 'Admin' || user?.role === 'Operator') && (
                    <>
                      <Link to="/admin" onClick={() => setUserMenuOpen(false)} className="dropdown-item">
                        🛠️ Admin Panel
                      </Link>
                      <Link to="/status" onClick={() => setUserMenuOpen(false)} className="dropdown-item">
                        🟢 Sistem Durumu
                      </Link>
                    </>
                  )}
                  <div className="dropdown-divider" />
                  <button onClick={() => { setUserMenuOpen(false); handleLogout(); }} className="dropdown-item text-danger">
                    <LogOut size={14} /> Çıkış
                  </button>
                </div>
              </div>
            ) : (
              <Link to="/login" className="btn btn-primary btn-sm">
                <LogIn size={16} /> Giriş Yap
              </Link>
            )}

            <button className="mobile-menu-btn" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
              {mobileMenuOpen ? <X size={22} /> : <Menu size={22} />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="mobile-menu">
            <Link to="/food" onClick={() => setMobileMenuOpen(false)} className="mobile-nav-link">
              🍔 Yemek
            </Link>
            <Link to="/market" onClick={() => setMobileMenuOpen(false)} className="mobile-nav-link">
              🛒 Market
            </Link>
            <Link to="/cart" onClick={() => setMobileMenuOpen(false)} className="mobile-nav-link">
              🛍️ Sepet {totalCount > 0 && `(${totalCount})`}
            </Link>
            {isAuthenticated && (
              <>
                <Link to="/orders" onClick={() => setMobileMenuOpen(false)} className="mobile-nav-link">📋 Siparişlerim</Link>
                <Link to="/favorites" onClick={() => setMobileMenuOpen(false)} className="mobile-nav-link">❤️ Favorilerim</Link>
                <Link to="/profile" onClick={() => setMobileMenuOpen(false)} className="mobile-nav-link">👤 Profilim</Link>
                <button onClick={handleLogout} className="mobile-nav-link text-danger" style={{background:'none',border:'none',textAlign:'left',width:'100%'}}>🚪 Çıkış</button>
              </>
            )}
            {!isAuthenticated && (
              <Link to="/login" onClick={() => setMobileMenuOpen(false)} className="mobile-nav-link">🔑 Giriş Yap</Link>
            )}
          </div>
        )}
      </nav>

      {/* ─── Page Content ─── */}
      <main className="page-main">
        <Outlet />
      </main>

      {/* ─── Footer ─── */}
      <footer className="footer">
        <div className="container" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' }}>
          <img src="/logo-transparent.png" alt="Zavadak" style={{ height: '28px', opacity: 0.85 }} />
          <p>© 2026 Zavadak.com · Tüm hakları saklıdır.</p>
        </div>
      </footer>
    </div>
  );
}
